import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PrivateRoute({ children, requireOnboarded = true }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="h-[100dvh] flex items-center justify-center bg-kudi-cream">
        <div className="text-kudi-green font-heading text-xl">Loading...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/signin" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboard" replace />;
  return children;
}
